import React from "react";
import {IconButton} from "@material-ui/core";
import AlertIcon from "view/images/AlertIcon";
import {blue} from "@material-ui/core/colors";
import useStyles from "./styles";

type IconProps = {
  viewOnly?: boolean;
  isRequired?: boolean;
  onClick: () => void;
};

const RequiredIcon = ({viewOnly, isRequired, onClick}: IconProps) => {
  const classes = useStyles();
  const iconColor = !viewOnly && isRequired ? blue.A100 : undefined;

  return (
    <IconButton
      className={classes.cellButton}
      onClick={!viewOnly ? onClick : undefined}
      disabled={viewOnly}
    >
      <AlertIcon fill={iconColor} />
    </IconButton>
  );
};

export default RequiredIcon;
